/**
 * Calculator Page Component
 * 
 * This component displays the price calculator interface
 * for calculating storage service prices.
 */

import React from 'react';
import EnhancedPriceCalculator from '../components/calculator/EnhancedPriceCalculator';

const CalculatorPage = () => {
  return <EnhancedPriceCalculator />;
};

export default CalculatorPage;
